import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  '&.widgetAlert': {
    marginBottom: theme.spacing(1),
    width: '100%',
  },
}));

export default StyledBox;
